/* eslint-disable standard/no-callback-literal */
// PageCompanyProfile Component

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import Util from '../../../lib/util.jsx'
import CompanyForm from '../../../common/company/company_form/company_form.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'
import { unflattenBillingInfo } from '../../subscription/subscription_content/mappers.js'
import { InvalidAddressError } from '../../../../shared/errors/InvalidAddressError.js'

class PageCompanyProfile extends BaseSettings {
  constructor (props) {
    super(
      props,
      'setting-companyprofile',
      'setting-user',
      'setting-companyprofile'
    )

    this.state = {
      isLoading: true,
      dataDate: null
    }

    this.data = {
      company: null
    }

    this._references = {
      pageHeader: React.createRef()
    }
    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  renderContent () {
    return (
      <CompanyForm
        company={this.data.company}
        onSubmit={this._onSubmit.bind(this)}
        showPaymentPeriod={!app.isQuickbookConnected()}
        onError={this._onError.bind(this)}
        onVatValidate={this._onVatValidate.bind(this)}
      />
    )
  }

  getContentClassname () {
    return 'alt'
  }

  /* Event Handlers */
  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onVatValidate (country, vatNo, callback) {
    if (vatNo !== undefined && vatNo) {
      const params = { query: { country: country, vatNumber: vatNo } }
      app
        .service('/api/page/vatvalidate')
        .find(params)
        .then(res => {
          if (res && res.bValid) {
            callback(true)
          } else {
            this._showVatError()
            callback(false)
          }
        })
        .catch(_err => {
          this._showVatError()
          callback(false)
        })
    } else {
      callback(true)
    }
  }

  _showVatError () {
    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showError(
        'setting.companyProfile.msgErrorTitle',
        'setting.companyProfile.msgInvalidVatNo'
      )
    }
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataProfile(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _onSubmit (company, imageAvatar, bImageDeleted, callback) {
    if (!app.isDemo) {
      this._saveProfile(company, imageAvatar, bImageDeleted, err => {
        if (err) {
          this._onError(err.translationKey)
        } else {
          app.setTeamCountry(company.country)
          if (this._references.pageHeader.current) {
            this._references.pageHeader.current.showSuccess(
              'setting.companyProfile.msgSuccessTitle',
              'setting.companyProfile.msgSuccessContent'
            )
          }
          if (callback) {
            callback()
          }
        }
      })
    } else {
      this.showError('setting.companyProfile.errorDemoMsg')
    }
  }

  _saveProfile (profile, imageAvatar, bImageDeleted, callback) {
    app.debug('PageCompanyProfile: _saveProfile [start]')

    const teamId = app.getTeamId()
    const profileData = Util.removeObjectKeys(_.cloneDeep(profile), [
      'id',
      'imageUrl'
    ])
    const patchTeamParams = {
      query: {
        $client: { imageAvatar: imageAvatar, imageDeleted: bImageDeleted }
      }
    }

    const findUserTeamParams = {
      query: { userId: app.loggedInId, teamId }
    }

    app
      .service('/api/users/team')
      .find(findUserTeamParams)
      .then(result => {
        if (result.data && result.data.length > 0) {
          return result.data[0]
        } else {
          throw new Error('Invalid user details')
        }
      })
      .then(user =>
        app.service('/api/subscription/billing').update(
          teamId,
          unflattenBillingInfo({
            firstName: user.firstName,
            lastName: user.lastName,
            line1: profileData.street,
            city: profileData.city,
            state: profileData.state,
            stateCode: profileData.state,
            country: profileData.country,
            postCode: profileData.postcode,
            vatNumber: profileData.vatNo
          })
        )
          .catch(err => {
            throw new InvalidAddressError(err)
          })
      )
      .then(() =>
        app
          .service('/api/team')
          .patch(teamId, { name: profile.company, profile: profileData }, patchTeamParams)
      )
      .then(profileRes => {
        if (profileRes) {
          app.setTeam(profileRes.id)
          callback(null)
        } else {
          callback({}) // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(profileErr => {
        app.debug('profileErr Edit', profileErr)
        callback(profileErr)
      })
  }

  _onError (field) {
    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showError(
        'setting.companyProfile.msgErrorTitle',
        field || 'setting.companyProfile.msgErrorInfo'
      )
    }
  }

  _getDataProfile (callback) {
    app.debug('PageCompanyProfile: _getDataProfile [start]')
    const teamId = app.getTeamId()
    app
      .service('/api/team')
      .get(teamId)
      .then(result => {
        this.data.company = result.profile
        this.data.company.image = result.image
        this.data.company.imageUrl = result.imageUrl
        callback(null)
      })
      .catch(err => {
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageCompanyProfile: _onDataReceived Error', err)
    } else {
      app.debug('PageCompanyProfile: _onDataReceived [done]')
    }
    this.setState({ isLoading: !!err, dataDate: new Date() })
  }
}

export default PageCompanyProfile
